import React from 'react';
import { createJoinableSitesProvider } from './default-joinable-sites-provider';
var _ref = createJoinableSitesProvider(),
  fetchJoinableSites = _ref.fetchMethod,
  DefaultDataProviderComponent = _ref.ProviderComponent;
export var JoinableSitesProvider = function JoinableSitesProvider(_ref2) {
  var children = _ref2.children,
    joinableSitesDataProvider = _ref2.joinableSitesDataProvider;
  var CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
  var DataProviderComponent = CustomDataProviderComponent || DefaultDataProviderComponent;
  return /*#__PURE__*/React.createElement(DataProviderComponent, null, children);
};
export var prefetchJoinableSites = function prefetchJoinableSites(customProvider) {
  if (customProvider) {
    customProvider.fetchMethod({});
    return;
  }
  fetchJoinableSites({});
};
export var resetJoinableSites = function resetJoinableSites(customProvider) {
  if (customProvider) {
    customProvider.fetchMethod.reset();
    return;
  }
  fetchJoinableSites.reset();
};